// NS-9951, store used only to send request for downloading files/data
import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import { clientShortName } from '@/helpers/clientShortName.js'
import vuecookie from 'vue-cookies'
import { data } from 'jquery';

const state = {
    
};

const getters = {
    
};

const actions = {
    async prepareDocumentsZip( context, data ) {
        return await axios.post(`${backendUrl()}/prepareDocumentsZip`,
        {
            docIds: data.documents
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },
    // NS-9981 SP
    async prepareMergedDocuments( context, data ) {
        return await axios.post(`${backendUrl()}/prepareMergedDocuments`,
        {
            documents: data.documents,
            userLevel: data.userLevel
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },
    // NS-10046 SP
    async prepareDocumentsInfoCsv( context, data ) {
        return await axios.post(`${backendUrl()}/prepareDocumentsInfoCsv`,
        {
            documents: data.documents
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            if (response.data.status == 'error') {
                context.dispatch('handleResponse', response, {root: true})
            }
            return response.data
        })
    },
    async prepareFilteredDocumentsInfoCsv( context, data ) {
        return await axios.post(`${backendUrl()}/prepareFilteredDocumentsInfoCsv`, data,
            {
                headers: { 'Authorization': "bearer " + vuecookie.get('token') }
            })
            .then(response => {
                if (response.data.status == 'error') {
                    context.dispatch('handleResponse', response, {root: true})
                }
                return response.data
            })
    },
    async prepareDocumentsHeaded( context, data ) {
        return await axios.post(`${backendUrl()}/prepareDocumentsHeaded`,
        {
            documents: data.documents,
            coversheets: data.coversheets
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            if (response.data.status == 'error') {
                context.dispatch('handleResponse', response, {root: true})
            }
            return response.data
        })
    },
    // NS-10057 prepare invite letters for downloading, VY
    async prepareMergedInviteLetters( context, data ) {
        return await axios.post(`${backendUrl()}/prepareMergedInviteLetters`,
            {
                document_batch_id: data.documentBatch,
                include_hidden: data.includeHidden,
                by_email: data.byEmail,
                duplicates: data.duplicates,
            },
            {
                headers: { 'Authorization': "bearer " + vuecookie.get('token') }
            })
            .then(response => {
                if (response.data.status == 'error') {
                    context.dispatch('handleResponse', response, {root: true})
                }
                return response.data
            })
    },
    // NS-10047 prepare invite letters for downloading, VY
    async prepareMergedDocumentsData(context, data) {
        return await axios.post(`${backendUrl()}/prepareMergedDocumentsData`,
            {
                documents: data.documents,
            },
            {
                headers: { 'Authorization': "bearer " + vuecookie.get('token') }
            })
            .then(response => {
                if (response.data.status == 'error') {
                    context.dispatch('handleResponse', response, {root: true})
                }
                return response.data
            })
    },
    // MTVN-11323 Spot report download, PW
    async prepareSpotReport(context, data) {
        return await axios.post(`${backendUrl()}/prepareSpotReport`,
            {
                documents: data.documents,
            },
            {
                headers: { 'Authorization': "bearer " + vuecookie.get('token') }
            })
            .then(response => {
                context.dispatch('handleResponse', response, {root: true})
                return response.data
            })
    }
};

const mutations = {

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


